import { TableColumn } from 'types/types'
import { ActionsContainer } from './SiteDetails.styled'
import { DeleteIcon, EditIcon } from 'components'
import { IconButton } from '@mui/material'
import { Company } from 'types/models'
import { TableActionConfig } from '../../../../components/Table/types'
import { TableActions } from '../../../../components/Table/TableActions'

export const siteDetailsTableColumns = <T,>({
  actions,
}: {
  actions: TableActionConfig<T>[]
}): TableColumn[] => [
  { id: 'name', label: 'Site', minWidth: 170 },
  {
    id: 'parent_id',
    label: 'Parent Site',
    minWidth: 100,
    format: (_, row) => {
      return <div>{row?.parent?.name || 'N/A'}</div>
    },
  },
  {
    id: 'actions',
    label: '',
    minWidth: 170,
    align: 'right',
    format: (_, row: T) => <TableActions actions={actions} row={row} />,
  },
]
